import clsx from "clsx";
import { ReactNode } from "react";
import { FieldError } from "react-hook-form";

export default function InputGroup({
  label,
  inputField,
  error,
  message,
}: {
  label?: ReactNode;
  inputField: ReactNode;
  error?: FieldError;
  message?: ReactNode;
}) {
  return (
    <div>
      {label && <div className="text-body-md-heavy">{label}</div>}
      <div className={clsx(label ? "mt-2" : "")}>{inputField}</div>
      {error && (
        <p className="text-body-sm text-accent mt-1">{error.message}</p>
      )}
      {!error && message && <p className="text-body-sm mt-1">{message}</p>}
    </div>
  );
}
